<ng-container *ngIf="giftDetails else errorLoadingGift">
    <div class="container-narrow my-5">
        <app-gift-card [gift]="giftDetails">
            <div class="d-flex flex-column
                 w-100
                 justify-content-center justify-content-md-end
                 text-center text-md-right
                 align-items-center align-items-md-end">
                <span class="mt-3 mb-4 d-flex text-white flex-fill align-items-center text-break">
                    {{ giftDetails.giftDescription }}
                </span>
                <span *ngIf="giftDetails.partnerWebsiteUrl"
                      class="text-white mb-4 text-break">
                    <a [attr.href]="giftDetails.partnerWebsiteUrl"
                       target="_blank"
                       class="text-white"
                       rel="nofollow noopener noreferrer">{{ giftDetails.partnerWebsiteUrl }}</a>
                </span>
            </div>
        </app-gift-card>
    </div>

    <ng-container *ngIf="!giftChosen else giftReservationSuccess">

        <div *ngIf="giftReservationError"
             class="container-narrow my-5 text-center">
            <span class="text-danger"
                  [translate]="'GIFTS.DETAILS-VIEW.ERROR-ALREADY-CHOOSED'">
            </span>
        </div>

        <div class="container-narrow text-center my-5">
            <div class="row justify-content-center">
                <div class="col-12 col-sm-6 col-md-5 col-lg-4 order-2 order-sm-1">
                    <button type="button"
                            class="btn btn-block btn-lg btn-outline-primary mb-4"
                            (click)="goBack()"
                            [translate]="'GIFTS.DETAILS-VIEW.BUTTON-SEE-OTHER-GIFTS'">
                    </button>
                </div>
                <div class="col-12 col-sm-6 col-md-5  col-lg-4 order-1 order-sm-2">
                    <button type="button"
                            class="btn btn-block btn-primary btn-lg mb-4"
                            (click)="chooseGift()"
                            [translate]="'GIFTS.DETAILS-VIEW.BUTTON-CHOOSE-GIFT'">
                    </button>
                </div>
            </div>
        </div>

    </ng-container>

    <ng-template #giftReservationSuccess>
        <div class="container-narrow text-center text-center mb-3">
            <div class="row justify-content-center">
                <div class="col-12 col-md-6">
                    <h2 class="h4 fw-bolder text-primary"
                        [translate]="'GIFTS.DETAILS-VIEW.RESERVATION-SUCCESS.TITLE'"></h2>
                    <p>
                        <span [translate]="'GIFTS.DETAILS-VIEW.RESERVATION-SUCCESS.DESCRIPTION'">
                        </span>
                        {{visitDetails.customerEmail}}
                    </p>
                </div>
            </div>
        </div>
        <div class="container-narrow mb-5">
            <div class="row d-flex justify-content-center">
                <div class="d-flex justify-content-center col-12 col-md-6 ">
                    <button class="btn btn-primary btn-lg btn-block shadow-sm"
                            (click)="bookAnotherVisit()"
                            [translate]="'BOOKING-PART.BOOKING-COMPLETED.BUTTON-ANOTHER-VISIT'"></button>
                </div>
            </div>
            <div *ngIf="visitDetails.canRedirectToSalonWebpageOnRouteBySalonId"
                 class="row d-flex justify-content-center mt-3">
                <div class="d-flex justify-content-center col-12 col-md-6 ">
                    <button class="btn btn-link btn-lg btn-block"
                            (click)="returnToSalonWebsite()">
                        <span [translate]="'BOOKING-PART.BOOKING-COMPLETED.BUTTON-RETURN-TO-WEBSITE'"
                              [translateParams]="{timeLeft: countdownRedirectInSeconds}">
                            {{ 'BOOKING-PART.BOOKING-COMPLETED.BUTTON-RETURN-TO-WEBSITE' | translate:
                            {timeLeft: countdownRedirectInSeconds} }}
                        </span>
                    </button>
                </div>
            </div>
        </div>

    </ng-template>
</ng-container>

<ng-template #errorLoadingGift>
    <div class="container-narrow my-5">
        <div class="row mt-5">
            <div class="col-12">
                <h1 class="h3 fw-bolder"
                    [translate]="'GIFTS.DETAILS-VIEW.ERROR-NO-GIFTS-FOUND.TITLE'"></h1>
                <p class="pre-wrap"
                   [translate]="'GIFTS.DETAILS-VIEW.ERROR-NO-GIFTS-FOUND.DESCRIPTION'"></p>
            </div>
        </div>
    </div>
</ng-template>
